import React from 'react'
import { Platform } from 'react-native'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Button } from '@zet/design-system/button'
import { Stack, XStack } from '@zet/design-system/layout'
import { Stepper } from '@zet/design-system/stepper'
import { i18n } from '@zet/localization'
import { BottomViewProps } from '@zet/utils/interface'

export const BottomView = ({
  stepCount = 1,
  maxCount = 5,
  navigationScreen,
  disabled = false,
  idCardPendingScreen = false,
  onPress,
  loading,
  buttonEvent,
  label = i18n.t('bottomView.continue'),
}: BottomViewProps) => {
  const navigation = useNavigation()

  return (
    <Stack
      className={
        Platform.OS === 'web'
          ? ' border-grays-30 border-t'
          : 'border-grays-30 h-10 w-full border-t bg-white'
      }
    >
      {idCardPendingScreen ? (
        <XStack className="mx-3 h-full items-center py-2">
          <Button
            size="lg"
            fullWidth
            disabled={disabled}
            onPress={() => {
              if (onPress) onPress()
              else navigation.goBack()
            }}
            loading={loading}
            eventName={buttonEvent?.eventName}
            eventPayload={buttonEvent?.payload}
          >
            {label}
          </Button>
        </XStack>
      ) : (
        <XStack className="mx-3 h-full items-center py-2">
          <Stack className="mr-5" style={{ flex: 4 }}>
            <Stepper
              intent="warning"
              maxCount={maxCount}
              minCount={stepCount}
              className="w-full"
            />
          </Stack>

          <Stack style={{ flex: 6 }}>
            <Button
              size="lg"
              fullWidth
              disabled={disabled}
              onPress={() => {
                if (navigationScreen) {
                  navigation.navigate(navigationScreen)
                } else {
                  onPress()
                }
              }}
              loading={loading}
              eventName={buttonEvent?.eventName}
              eventPayload={buttonEvent?.payload}
            >
              {i18n.t('bottomView.continue')}
            </Button>
          </Stack>
        </XStack>
      )}
    </Stack>
  )
}
